export const OPEN_MODAL = 'OPEN_MODAL';
export const CLOSE_MODAL = 'CLOSE_MODAL';



// WEBPACK FOOTER //
// ./src/actionTypes/modalActionTypes.js